import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux/store";

const user = (state: RootState) => state.users_reducer;
export const allUsers = createSelector(
  [user],
  (users) => users?.allUsersResponse
);
